// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-tree-canvas-container {
  overflow: hidden !important; /* Hide native scrollbars as library handles panning */
  position: relative;
  height: 100%; 
  width: 100%;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

/* react-zoom-pan-pinch wrapper adjustment */
.react-transform-component {
  width: 100% !important;
  height: 100% !important;
}

.network-tree-infinite-plane-wrapper {
  display: flex;
  justify-content: center;
  min-width: 100%;
}

.network-tree-canvas-container::-webkit-scrollbar {
  display: none;
}

.network-tree-search-bar {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: auto; /* Allow content to define width */
  min-width: 320px;
  max-width: 450px;
}

.network-tree-search-form {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  padding: 8px 16px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.network-tree-search-form:focus-within {
  box-shadow: 0 12px 35px rgba(35, 75, 154, 0.12);
  border-color: rgba(35, 75, 154, 0.4);
  transform: translateY(-1px);
}

.network-tree-search-icon {
  margin-right: 12px;
  color: #6b7280;
}

.network-tree-search-input {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 4px 0;
  font-size: 13.5px;
  color: #111827;
  outline: none;
}

.network-tree-search-input::placeholder {
  color: #9ca3af;
}

.network-tree-search-input:focus {
  /* Removed the big shadow here to avoid secondary box effect */
  box-shadow: none;
}

.network-tree-infinite-plane {
  position: relative;
  z-index: 10;
  width: max-content;
  min-width: 100%;
  display: flex;
  justify-content: center;
  padding-left: 4000px;
  padding-right: 4000px;
  padding-bottom: 2000px;
  padding-top: 40px;
}

.tree-node-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  transition: all 0.3s ease;
  will-change: transform;
}

.tree-node-anchor {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
}

.vertical-connector-primary {
  width: 2px;
  height: 2rem;
  background-color: rgba(35, 75, 154, 0.6);
  margin-horizontal: auto;
}

.children-row-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-top: 4px;
}

/* Sleek Pagination Card styling matching the node dimensions for perfect flow */
.pagination-card {
  width: 260px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(35, 75, 154, 0.04) !important;
  border: 1.5px dashed rgba(35, 75, 154, 0.3) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02) !important;
  padding: 24px 16px !important;
  border-radius: 14px !important;
  min-height: 130px; /* Aligns visually with the typical user-card height */
  transition: all 0.3s ease !important;
}

.pagination-card:hover {
  background: rgba(35, 75, 154, 0.08) !important;
  border-color: rgba(35, 75, 154, 0.6) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(35, 75, 154, 0.1) !important;
}

.pagination-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.pagination-icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  color: #234b9a;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(35, 75, 154, 0.15);
  transition: all 0.2s ease;
}

.pagination-card:hover .pagination-icon-circle {
  background: #234b9a;
  color: white;
  transform: scale(1.08);
}

.pagination-text-primary {
  font-weight: 700;
  font-size: 14px;
  color: #234b9a;
  margin-top: 2px;
}

.pagination-text-secondary {
  font-size: 11px;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.children-list-flex {
  display: flex;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
}

.child-node-slot {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1rem 0 1rem;
}

.horizontal-connector-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 2px;
  background-color: rgba(35, 75, 154, 0.6);
}

.horizontal-connector-right {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 2px;
  background-color: rgba(35, 75, 154, 0.6);
}

.vertical-connector-child {
  position: absolute;
  top: 0;
  left: 50%;
  width: 2px;
  height: 2rem;
  background-color: rgba(35, 75, 154, 0.6);
  transform: translateX(-1px);
}

.user-card-glass {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 16px; /* Increased padding */
  width: 260px;  /* Increased width to prevent overflow */
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.8);
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(14px);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
  overflow: hidden; /* Safety catch */
}

.user-card-glass.expanded {
  background: rgba(255, 255, 255, 0.8);
  border-color: #234b9a;
  box-shadow: 0 4px 20px rgba(35, 75, 154, 0.15);
}

.user-card-glass.root-node:not(.expanded) {
  border-color: rgba(35, 75, 154, 0.4);
  box-shadow: 0 4px 15px rgba(35, 75, 154, 0.1);
}

.user-card-glass.interactive {
  cursor: pointer;
}

.user-card-glass.interactive:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.user-card-title {
  font-weight: 700;
  color: #111827;
  font-size: 15px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px; /* Constraining name width */
}

.user-card-wallet {
  font-size: 11px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 3px;
  font-family: monospace;
  margin-top: 2px;
}

.user-card-level-badge {
  display: inline-block;
  white-space: nowrap;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid transparent;
}

.badge-gold { background: rgba(234, 179, 8, 0.1); color: #eab308; border-color: rgba(234, 179, 8, 0.3); }
.badge-blue { background: rgba(59, 130, 246, 0.1); color: #3b82f6; border-color: rgba(59, 130, 246, 0.3); }
.badge-purple { background: rgba(168, 85, 247, 0.1); color: #a855f7; border-color: rgba(168, 85, 247, 0.3); }
.badge-emerald { background: rgba(16, 185, 129, 0.1); color: #10b981; border-color: rgba(16, 185, 129, 0.3); }

.user-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid rgba(0,0,0,0.05);
  font-size: 11px;
  color: #6b7280;
}

.referral-pill {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #234b9a;
  background: rgba(35, 75, 154, 0.1);
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.2s;
  font-size: 11px;
}

/* Modal Content Reset for User Details - Wide Layout (12:9) */
.custom-user-detail-modal {
  width: 100% !important;
  max-width: 1100px !important;
  height: auto !important;
  background: white !important;
  border: 1px solid rgba(0,0,0,0.1) !important;
  border-radius: 20px !important;
  box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
}

.custom-user-detail-modal .modal-body {
  min-height: 500px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 2rem !important;
}

.x-small {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* ==========================================================================
   ADAPTIVE MODE - VERTICAL TREE CASCADING RULES
   ========================================================================== */

.adaptive-layout .children-row-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  margin-top: 0;
  padding-left: 280px; /* Aligns children perfectly indented under the parent node card */
}

/* Left vertical pipeline that links all children under a parent */
.adaptive-layout .children-row-container::before {
  content: '';
  position: absolute;
  top: -2rem;
  left: 200px; /* Pipeline placement center point */
  width: 2px;
  height: calc(100% - 1.5rem); /* Dynamically terminates at the last child node slot */
  background-color: rgba(35, 75, 154, 0.4);
  z-index: 5;
}

.adaptive-layout .children-list-flex {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.adaptive-layout .child-node-slot {
  padding: 1.5rem 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

/* Horizontal connectors branching from the main pipeline into each child card */
.adaptive-layout .vertical-connector-child {
  position: absolute;
  top: calc(1.5rem + 25px); /* Centers horizontally with the user card */
  left: -80px; /* Extends to meet the main pipeline line */
  width: 80px;
  height: 2px;
  background-color: rgba(35, 75, 154, 0.4);
  transform: none;
  z-index: 5;
}

/* Primary drop line leading out of any parent node */
.adaptive-layout .vertical-connector-primary {
  width: 2px;
  height: 3.5rem; /* Elongate link downwards */
  background-color: rgba(35, 75, 154, 0.4);
  position: absolute;
  bottom: -3.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

/* Deactivate all horizontal rules of standard landscape view */
.adaptive-layout .horizontal-connector-left,
.adaptive-layout .horizontal-connector-right {
  display: none !important;
}

/* Position adjustments for pagination switches in vertical view */
.adaptive-layout .pagination-left,
.adaptive-layout .pagination-right {
  position: relative;
  padding: 0;
  margin-left: 200px;
  margin-top: 10px;
  left: 0;
  right: 0;
  z-index: 20;
}

/* ==========================================================================
   SEARCH TARGET HIGHLIGHT AND PULSING EFFECTS
   ========================================================================== */

.searched-target-glow {
  border-color: #f59e0b !important; /* Elegant Gold Border */
  background: rgba(254, 243, 199, 0.9) !important; /* Soft Amber Background */
  box-shadow: 0 0 25px rgba(245, 158, 11, 0.6) !important;
  animation: targetPulse 1.8s infinite ease-in-out;
  transform: scale(1.03);
}

@keyframes targetPulse {
  0% {
    box-shadow: 0 0 15px rgba(245, 158, 11, 0.4);
    border-color: #d97706 !important;
  }
  50% {
    box-shadow: 0 0 35px rgba(245, 158, 11, 0.9);
    border-color: #f59e0b !important;
  }
  100% {
    box-shadow: 0 0 15px rgba(245, 158, 11, 0.4);
    border-color: #d97706 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ValidatorDelegator/NetworkTree.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B,EAAE,sDAAsD;EACnF,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,WAAW,EAAE,kCAAkC;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,sDAAsD;EACtD,qDAAqD;EACrD,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB,EAAE,sDAAsD;EACzE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,sBAAsB;EACrC,YAAY,GAAG,wCAAwC;EACvD,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB,EAAE,iBAAiB;AACrC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,cAAc,kCAAkC,EAAE,cAAc,EAAE,oCAAoC,EAAE;AACxG,cAAc,mCAAmC,EAAE,cAAc,EAAE,qCAAqC,EAAE;AAC1G,gBAAgB,mCAAmC,EAAE,cAAc,EAAE,qCAAqC,EAAE;AAC5G,iBAAiB,mCAAmC,EAAE,cAAc,EAAE,qCAAqC,EAAE;;AAE7G;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;EAC5B,4CAA4C;EAC5C,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,kEAAkE;AACzF;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAE,oCAAoC;EACjD,UAAU;EACV,2BAA2B,EAAE,uDAAuD;EACpF,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,wBAAwB,EAAE,4CAA4C;EACtE,WAAW,EAAE,2CAA2C;EACxD,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,cAAc,EAAE,4BAA4B;EAC5C,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;;EAEE,wBAAwB;AAC1B;;AAEA,kEAAkE;AAClE;;EAEE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;;+EAE+E;;AAE/E;EACE,gCAAgC,EAAE,wBAAwB;EAC1D,+CAA+C,EAAE,0BAA0B;EAC3E,uDAAuD;EACvD,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE;IACE,4CAA4C;IAC5C,gCAAgC;EAClC;EACA;IACE,4CAA4C;IAC5C,gCAAgC;EAClC;EACA;IACE,4CAA4C;IAC5C,gCAAgC;EAClC;AACF","sourcesContent":[".network-tree-canvas-container {\n  overflow: hidden !important; /* Hide native scrollbars as library handles panning */\n  position: relative;\n  height: 100%; \n  width: 100%;\n  cursor: grab;\n  user-select: none;\n}\n\n/* react-zoom-pan-pinch wrapper adjustment */\n.react-transform-component {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.network-tree-infinite-plane-wrapper {\n  display: flex;\n  justify-content: center;\n  min-width: 100%;\n}\n\n.network-tree-canvas-container::-webkit-scrollbar {\n  display: none;\n}\n\n.network-tree-search-bar {\n  position: absolute;\n  top: 25px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: auto; /* Allow content to define width */\n  min-width: 320px;\n  max-width: 450px;\n}\n\n.network-tree-search-form {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 8px 16px;\n  border-radius: 12px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.network-tree-search-form:focus-within {\n  box-shadow: 0 12px 35px rgba(35, 75, 154, 0.12);\n  border-color: rgba(35, 75, 154, 0.4);\n  transform: translateY(-1px);\n}\n\n.network-tree-search-icon {\n  margin-right: 12px;\n  color: #6b7280;\n}\n\n.network-tree-search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 4px 0;\n  font-size: 13.5px;\n  color: #111827;\n  outline: none;\n}\n\n.network-tree-search-input::placeholder {\n  color: #9ca3af;\n}\n\n.network-tree-search-input:focus {\n  /* Removed the big shadow here to avoid secondary box effect */\n  box-shadow: none;\n}\n\n.network-tree-infinite-plane {\n  position: relative;\n  z-index: 10;\n  width: max-content;\n  min-width: 100%;\n  display: flex;\n  justify-content: center;\n  padding-left: 4000px;\n  padding-right: 4000px;\n  padding-bottom: 2000px;\n  padding-top: 40px;\n}\n\n.tree-node-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  transition: all 0.3s ease;\n  will-change: transform;\n}\n\n.tree-node-anchor {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 10;\n}\n\n.vertical-connector-primary {\n  width: 2px;\n  height: 2rem;\n  background-color: rgba(35, 75, 154, 0.6);\n  margin-horizontal: auto;\n}\n\n.children-row-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  margin-top: 4px;\n}\n\n/* Sleek Pagination Card styling matching the node dimensions for perfect flow */\n.pagination-card {\n  width: 260px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background: rgba(35, 75, 154, 0.04) !important;\n  border: 1.5px dashed rgba(35, 75, 154, 0.3) !important;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02) !important;\n  padding: 24px 16px !important;\n  border-radius: 14px !important;\n  min-height: 130px; /* Aligns visually with the typical user-card height */\n  transition: all 0.3s ease !important;\n}\n\n.pagination-card:hover {\n  background: rgba(35, 75, 154, 0.08) !important;\n  border-color: rgba(35, 75, 154, 0.6) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 8px 20px rgba(35, 75, 154, 0.1) !important;\n}\n\n.pagination-card-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.pagination-icon-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: white;\n  color: #234b9a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(35, 75, 154, 0.15);\n  transition: all 0.2s ease;\n}\n\n.pagination-card:hover .pagination-icon-circle {\n  background: #234b9a;\n  color: white;\n  transform: scale(1.08);\n}\n\n.pagination-text-primary {\n  font-weight: 700;\n  font-size: 14px;\n  color: #234b9a;\n  margin-top: 2px;\n}\n\n.pagination-text-secondary {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.children-list-flex {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.child-node-slot {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.5rem 1rem 0 1rem;\n}\n\n.horizontal-connector-left {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 2px;\n  background-color: rgba(35, 75, 154, 0.6);\n}\n\n.horizontal-connector-right {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 50%;\n  height: 2px;\n  background-color: rgba(35, 75, 154, 0.6);\n}\n\n.vertical-connector-child {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 2px;\n  height: 2rem;\n  background-color: rgba(35, 75, 154, 0.6);\n  transform: translateX(-1px);\n}\n\n.user-card-glass {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  padding: 16px; /* Increased padding */\n  width: 260px;  /* Increased width to prevent overflow */\n  border-radius: 14px;\n  border: 1px solid rgba(255,255,255,0.8);\n  transition: all 0.3s;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(14px);\n  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);\n  overflow: hidden; /* Safety catch */\n}\n\n.user-card-glass.expanded {\n  background: rgba(255, 255, 255, 0.8);\n  border-color: #234b9a;\n  box-shadow: 0 4px 20px rgba(35, 75, 154, 0.15);\n}\n\n.user-card-glass.root-node:not(.expanded) {\n  border-color: rgba(35, 75, 154, 0.4);\n  box-shadow: 0 4px 15px rgba(35, 75, 154, 0.1);\n}\n\n.user-card-glass.interactive {\n  cursor: pointer;\n}\n\n.user-card-glass.interactive:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n}\n\n.user-card-title {\n  font-weight: 700;\n  color: #111827;\n  font-size: 15px;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px; /* Constraining name width */\n}\n\n.user-card-wallet {\n  font-size: 11px;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-family: monospace;\n  margin-top: 2px;\n}\n\n.user-card-level-badge {\n  display: inline-block;\n  white-space: nowrap;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  border: 1px solid transparent;\n}\n\n.badge-gold { background: rgba(234, 179, 8, 0.1); color: #eab308; border-color: rgba(234, 179, 8, 0.3); }\n.badge-blue { background: rgba(59, 130, 246, 0.1); color: #3b82f6; border-color: rgba(59, 130, 246, 0.3); }\n.badge-purple { background: rgba(168, 85, 247, 0.1); color: #a855f7; border-color: rgba(168, 85, 247, 0.3); }\n.badge-emerald { background: rgba(16, 185, 129, 0.1); color: #10b981; border-color: rgba(16, 185, 129, 0.3); }\n\n.user-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 10px;\n  border-top: 1px solid rgba(0,0,0,0.05);\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.referral-pill {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  color: #234b9a;\n  background: rgba(35, 75, 154, 0.1);\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-weight: 600;\n  transition: all 0.2s;\n  font-size: 11px;\n}\n\n/* Modal Content Reset for User Details - Wide Layout (12:9) */\n.custom-user-detail-modal {\n  width: 100% !important;\n  max-width: 1100px !important;\n  height: auto !important;\n  background: white !important;\n  border: 1px solid rgba(0,0,0,0.1) !important;\n  border-radius: 20px !important;\n  box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;\n}\n\n.custom-user-detail-modal .modal-body {\n  min-height: 500px;\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 2rem !important;\n}\n\n.x-small {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n/* ==========================================================================\n   ADAPTIVE MODE - VERTICAL TREE CASCADING RULES\n   ========================================================================== */\n\n.adaptive-layout .children-row-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: relative;\n  width: 100%;\n  margin-top: 0;\n  padding-left: 280px; /* Aligns children perfectly indented under the parent node card */\n}\n\n/* Left vertical pipeline that links all children under a parent */\n.adaptive-layout .children-row-container::before {\n  content: '';\n  position: absolute;\n  top: -2rem;\n  left: 200px; /* Pipeline placement center point */\n  width: 2px;\n  height: calc(100% - 1.5rem); /* Dynamically terminates at the last child node slot */\n  background-color: rgba(35, 75, 154, 0.4);\n  z-index: 5;\n}\n\n.adaptive-layout .children-list-flex {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.adaptive-layout .child-node-slot {\n  padding: 1.5rem 0 0 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  width: 100%;\n}\n\n/* Horizontal connectors branching from the main pipeline into each child card */\n.adaptive-layout .vertical-connector-child {\n  position: absolute;\n  top: calc(1.5rem + 25px); /* Centers horizontally with the user card */\n  left: -80px; /* Extends to meet the main pipeline line */\n  width: 80px;\n  height: 2px;\n  background-color: rgba(35, 75, 154, 0.4);\n  transform: none;\n  z-index: 5;\n}\n\n/* Primary drop line leading out of any parent node */\n.adaptive-layout .vertical-connector-primary {\n  width: 2px;\n  height: 3.5rem; /* Elongate link downwards */\n  background-color: rgba(35, 75, 154, 0.4);\n  position: absolute;\n  bottom: -3.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 5;\n}\n\n/* Deactivate all horizontal rules of standard landscape view */\n.adaptive-layout .horizontal-connector-left,\n.adaptive-layout .horizontal-connector-right {\n  display: none !important;\n}\n\n/* Position adjustments for pagination switches in vertical view */\n.adaptive-layout .pagination-left,\n.adaptive-layout .pagination-right {\n  position: relative;\n  padding: 0;\n  margin-left: 200px;\n  margin-top: 10px;\n  left: 0;\n  right: 0;\n  z-index: 20;\n}\n\n/* ==========================================================================\n   SEARCH TARGET HIGHLIGHT AND PULSING EFFECTS\n   ========================================================================== */\n\n.searched-target-glow {\n  border-color: #f59e0b !important; /* Elegant Gold Border */\n  background: rgba(254, 243, 199, 0.9) !important; /* Soft Amber Background */\n  box-shadow: 0 0 25px rgba(245, 158, 11, 0.6) !important;\n  animation: targetPulse 1.8s infinite ease-in-out;\n  transform: scale(1.03);\n}\n\n@keyframes targetPulse {\n  0% {\n    box-shadow: 0 0 15px rgba(245, 158, 11, 0.4);\n    border-color: #d97706 !important;\n  }\n  50% {\n    box-shadow: 0 0 35px rgba(245, 158, 11, 0.9);\n    border-color: #f59e0b !important;\n  }\n  100% {\n    box-shadow: 0 0 15px rgba(245, 158, 11, 0.4);\n    border-color: #d97706 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
